import React from 'react';
import { IconProps } from '../types';
const MinecraftTrialKey: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="5" y="0" width="1" height="1" fill="rgba(69, 74, 66, 255)" />
<rect x="6" y="0" width="1" height="1" fill="rgba(69, 74, 66, 255)" />
<rect x="7" y="0" width="1" height="1" fill="rgba(69, 74, 66, 255)" />
<rect x="8" y="0" width="1" height="1" fill="rgba(69, 74, 66, 255)" />
<rect x="9" y="0" width="1" height="1" fill="rgba(69, 74, 66, 255)" />
<rect x="10" y="0" width="1" height="1" fill="rgba(41, 40, 40, 255)" />
<rect x="4" y="1" width="1" height="1" fill="rgba(69, 74, 66, 255)" />
<rect x="5" y="1" width="1" height="1" fill="rgba(82, 90, 81, 255)" />
<rect x="6" y="1" width="1" height="1" fill="rgba(161, 158, 148, 255)" />
<rect x="7" y="1" width="1" height="1" fill="rgba(161, 158, 148, 255)" />
<rect x="8" y="1" width="1" height="1" fill="rgba(133, 131, 122, 255)" />
<rect x="9" y="1" width="1" height="1" fill="rgba(108, 113, 107, 255)" />
<rect x="10" y="1" width="1" height="1" fill="rgba(82, 90, 81, 255)" />
<rect x="11" y="1" width="1" height="1" fill="rgba(41, 40, 40, 255)" />
<rect x="4" y="2" width="1" height="1" fill="rgba(69, 74, 66, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(133, 131, 122, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(108, 113, 107, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(108, 113, 107, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(108, 113, 107, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(108, 113, 107, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(108, 113, 107, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(41, 40, 40, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(69, 74, 66, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(108, 113, 107, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(255, 153, 81, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(82, 90, 81, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(82, 90, 81, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(255, 153, 81, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(82, 90, 81, 255)" />
<rect x="11" y="3" width="1" height="1" fill="rgba(41, 40, 40, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(69, 74, 66, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(108, 113, 107, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(82, 90, 81, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(161, 158, 148, 255)" />
<rect x="8" y="4" width="1" height="1" fill="rgba(108, 113, 107, 255)" />
<rect x="9" y="4" width="1" height="1" fill="rgba(82, 90, 81, 255)" />
<rect x="10" y="4" width="1" height="1" fill="rgba(108, 113, 107, 255)" />
<rect x="11" y="4" width="1" height="1" fill="rgba(41, 40, 40, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(55, 59, 53, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(82, 90, 81, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(55, 59, 53, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(55, 59, 53, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(82, 90, 81, 255)" />
<rect x="10" y="5" width="1" height="1" fill="rgba(41, 40, 40, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(41, 40, 40, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(55, 59, 53, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(132, 67, 45, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(132, 67, 45, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(55, 59, 53, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(41, 40, 40, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(55, 59, 53, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(41, 40, 40, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(154, 80, 56, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(132, 67, 45, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(41, 40, 40, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(55, 59, 53, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(154, 80, 56, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(154, 80, 56, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(84, 40, 26, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(193, 90, 54, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(154, 80, 56, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(84, 40, 26, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(214, 123, 91, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(193, 90, 54, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(84, 40, 26, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(252, 153, 130, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(193, 90, 54, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(154, 80, 56, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="6" y="12" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(252, 153, 130, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(252, 153, 130, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(214, 123, 91, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(214, 123, 91, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(84, 40, 26, 255)" />
<rect x="6" y="13" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="7" y="13" width="1" height="1" fill="rgba(252, 153, 130, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(214, 123, 91, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(84, 40, 26, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(84, 40, 26, 255)" />
<rect x="6" y="14" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="7" y="14" width="1" height="1" fill="rgba(214, 123, 91, 255)" />
<rect x="8" y="14" width="1" height="1" fill="rgba(214, 123, 91, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(214, 123, 91, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(193, 90, 54, 255)" />
<rect x="11" y="14" width="1" height="1" fill="rgba(109, 52, 33, 255)" />
<rect x="6" y="15" width="1" height="1" fill="rgba(84, 40, 26, 255)" />
<rect x="7" y="15" width="1" height="1" fill="rgba(84, 40, 26, 255)" />
<rect x="8" y="15" width="1" height="1" fill="rgba(84, 40, 26, 255)" />
<rect x="9" y="15" width="1" height="1" fill="rgba(84, 40, 26, 255)" />
<rect x="10" y="15" width="1" height="1" fill="rgba(84, 40, 26, 255)" />
<rect x="11" y="15" width="1" height="1" fill="rgba(84, 40, 26, 255)" />
</svg>);
export default MinecraftTrialKey;